<template lang="html">
  <v-card>
    <v-list two-line>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="blue">flag</v-icon>
        </v-list-item-action>
        <v-list-item-content v-if="getProjectDataEditing !== ''">
          <!-- <v-text-field placeholder="Country" :value="address.country" @input="setProjectAddressCountry({project_id: project_id, decider: getProjectDataEditing, event: $event})"></v-text-field> -->
          <v-text-field
            :placeholder="$t('Project.Settings.Locations.Data.Country')"
            :value="address.country"
            @input="updateUDObject({
              url: [
                {projects: project_id}
              ],
              update: {
                [getProjectDataEditing === 'Address'?'address':'invoice_address']: Object.assign(JSON.parse(JSON.stringify(address)), {country: $event})
              }
            })"
            />
        </v-list-item-content>
        <v-list-item-content v-else>
          <v-list-item-title>{{address.country}}</v-list-item-title>
          <v-list-item-subtitle>{{$t('Project.Settings.Locations.Data.Country')}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="ma-0"></v-divider>

         <!-- Zip Code -->
      <v-list-item>
        <v-list-item-action>
          <v-icon color="blue">mail</v-icon>
        </v-list-item-action>
        <v-list-item-content v-if="getProjectDataEditing !== ''">
          <!-- <v-text-field placeholder="Zip Code" :value="address.zip_code" @input="setProjectAddressZipCode({project_id: project_id, decider: getProjectDataEditing, event: $event})"></v-text-field> -->
          <v-text-field
            :placeholder="$t('Project.Settings.Locations.Data.ZipCode')"
            :value="address.zip_code"
            @input="updateUDObject({
              url: [
                {projects: project_id}
              ],
              update: {
                [getProjectDataEditing === 'Address'?'address':'invoice_address']: Object.assign(JSON.parse(JSON.stringify(address)), {zip_code: $event})
              }
            })"
            />
        </v-list-item-content>
        <v-list-item-content v-else>
          <v-list-item-title>{{address.zip_code}}</v-list-item-title>
          <v-list-item-subtitle>{{$t('Project.Settings.Locations.Data.ZipCode')}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="ma-0"></v-divider>

      <!-- State -->
      <v-list-item>
        <v-list-item-action>
          <v-icon color="blue">account_balance</v-icon>
        </v-list-item-action>
        <v-list-item-content v-if="getProjectDataEditing !== ''">
          <!-- <v-text-field placeholder="State" :value="address.state" @input="setProjectAddressState({project_id: project_id, decider: getProjectDataEditing, event: $event})"></v-text-field> -->
          <v-text-field
            :placeholder="$t('Project.Settings.Locations.Data.State')"
            :value="address.state"
            @input="updateUDObject({
              url: [
                {projects: project_id}
              ],
              update: {
                [getProjectDataEditing === 'Address'?'address':'invoice_address']: Object.assign(JSON.parse(JSON.stringify(address)), {state: $event})
              }
            })"
            />
        </v-list-item-content>
        <v-list-item-content v-else>
          <v-list-item-title>{{address.state}}</v-list-item-title>
          <v-list-item-subtitle>{{$t('Project.Settings.Locations.Data.State')}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="ma-0"></v-divider>

      <!-- City -->
      <v-list-item>
        <v-list-item-action>
          <v-icon color="blue">location_city</v-icon>
        </v-list-item-action>
        <v-list-item-content v-if="getProjectDataEditing !== ''">
          <!-- <v-text-field placeholder="City" :value="address.city" @input="setProjectAddressCity({project_id: project_id, decider: getProjectDataEditing, event: $event})"></v-text-field> -->
          <v-text-field
            :placeholder="$t('Project.Settings.Locations.Data.City')"
            :value="address.city"
            @input="updateUDObject({
              url: [
                {projects: project_id}
              ],
              update: {
                [getProjectDataEditing === 'Address'?'address':'invoice_address']: Object.assign(address, {city: $event})
              }
            })"
            />
        </v-list-item-content>
        <v-list-item-content v-else>
          <v-list-item-title>{{address.city}}</v-list-item-title>
          <v-list-item-subtitle>{{$t('Project.Settings.Locations.Data.City')}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="ma-0"></v-divider>

      <!-- Street -->
      <v-list-item>
        <v-list-item-action>
          <v-icon color="blue">local_movies</v-icon>
        </v-list-item-action>
        <v-list-item-content v-if="getProjectDataEditing !== ''">
          <!-- <v-text-field placeholder="Street" :value="address.street" @input="setProjectAddressStreet({project_id: project_id, decider: getProjectDataEditing, event: $event})"></v-text-field> -->
          <v-text-field
            :placeholder="$t('Project.Settings.Locations.Data.Street')"
            :value="address.street"
            @input="updateUDObject({
              url: [
                {projects: project_id}
              ],
              update: {
                [getProjectDataEditing === 'Address'?'address':'invoice_address']: Object.assign(JSON.parse(JSON.stringify(address)), {street: $event})
              }
            })"
            />
        </v-list-item-content>
        <v-list-item-content v-else>
          <v-list-item-title>{{address.street}}</v-list-item-title>
          <v-list-item-subtitle>{{$t('Project.Settings.Locations.Data.Street')}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="ma-0"></v-divider>

      <!-- Building Number -->
      <v-list-item>
        <v-list-item-action>
          <v-icon color="blue">local_convenience_store</v-icon>
        </v-list-item-action>
        <v-list-item-content v-if="getProjectDataEditing !== ''">
          <!-- <v-text-field placeholder="Building Number" :value="address.building_number" @input="setProjectAddressBuildingNumber({project_id: project_id, decider: getProjectDataEditing, event: $event})"></v-text-field> -->
          <v-text-field
            :placeholder="$t('Project.Settings.Locations.Data.BuildingNumber')"
            :value="address.building_number"
            @input="updateUDObject({
              url: [
                {projects: project_id}
              ],
              update: {
                [getProjectDataEditing === 'Address'?'address':'invoice_address']: Object.assign(JSON.parse(JSON.stringify(address)), {building_number: $event})
              }
            })"
            />
        </v-list-item-content>
        <v-list-item-content v-else>
          <v-list-item-title>{{address.building_number}}</v-list-item-title>
          <v-list-item-subtitle>{{$t('Project.Settings.Locations.Data.BuildingNumber')}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="ma-0"></v-divider>

      <!-- Custom Information -->
      <v-list-item>
        <v-list-item-action>
          <v-icon color="blue">star</v-icon>
        </v-list-item-action>
        <v-list-item-content v-if="getProjectDataEditing !== ''">
          <!-- <v-text-field placeholder="Additional Information" :value="address.custom_information" @input="setProjectAddressCustomInformation({project_id: project_id, decider: getProjectDataEditing, event: $event})"></v-text-field> -->
          <v-text-field
            :placeholder="$t('Project.Settings.Locations.Data.AdditionalInformation')"
            :value="address.custom_information"
            @input="updateUDObject({
              url: [
                {projects: project_id}
              ],
              update: {
                [getProjectDataEditing === 'Address'?'address':'invoice_address']: Object.assign(JSON.parse(JSON.stringify(address)), {custom_information: $event})
              }
            })"
            />
        </v-list-item-content>
        <v-list-item-content v-else>
          <v-list-item-title>{{address.custom_information}}</v-list-item-title>
          <v-list-item-subtitle>{{$t('Project.Settings.Locations.Data.AdditionalInformation')}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="ma-0"></v-divider>
    </v-list>
  </v-card>
</template>

<script>
import {
  mapGetters, mapActions
} from 'vuex';
export default {
  components: {
  },
  props: ['address', 'project_id'],
  data: function () {
    return {

    }
  },
  computed: {
    ...mapGetters('View', [
      'getProjectDataEditing'
    ])
  },
  methods: {
    ...mapActions('Project', [
      'setProjectAddressCountry',
      'setProjectAddressZipCode',
      'setProjectAddressState',
      'setProjectAddressCity',
      'setProjectAddressStreet',
      'setProjectAddressBuildingNumber',
      'setProjectAddressCustomInformation'
    ]),
    ...mapActions('UltraDev', [
      'updateUDObject'
    ])
  }
}
</script>

<style lang="css" scoped>
</style>
